module.exports = __webpack_public_path__ + "static/media/MONTHLY_NIGHT_MODE.ddc38964.png";